import { useState, type FormEvent } from 'react';

import type { IdentityStore } from '../stores/identity-store';
import { BrandMark } from './BrandMark';
import './login-screen.css';

export function LoginScreen({
  identity,
  pending,
  error,
}: {
  readonly identity: Pick<IdentityStore, 'login'>;
  readonly pending: boolean;
  readonly error: string | null;
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (pending) return;
    void identity.login(username, password).catch(() => undefined);
  };

  return (
    <main className="login-page">
      <header className="login-page__header">
        <div className="brand brand--static login-page__brand">
          <BrandMark />
          <span>
            <strong>弈时围棋</strong>
            <small>围棋教学与对弈平台</small>
          </span>
        </div>
      </header>

      <div className="login-page__content">
        <div className="login-page__surface">
          <section className="login-page__intro" aria-label="围棋平台介绍">
            <div className="login-page__intro-copy">
              <p className="login-page__eyebrow">从一手棋，开始</p>
              <h1>
                在黑白之间，
                <br />
                看见每一步成长。
              </h1>
              <p className="login-page__description">学习、对弈、复盘。</p>
            </div>
            <div className="login-page__illustration" aria-hidden="true">
              <img
                src="/assets/warm-home/go-corner.webp"
                width="1604"
                height="980"
                alt=""
                decoding="async"
                draggable={false}
              />
            </div>
          </section>

          <section className="login-page__panel" aria-labelledby="login-heading">
            <form className="login-page__form" onSubmit={submit} aria-busy={pending}>
              <div className="login-page__heading">
                <span className="login-page__welcome">欢迎回来</span>
                <h2 id="login-heading">登录弈时围棋</h2>
                <p>使用现有账号，继续你的围棋之旅。</p>
              </div>
              <label className="login-page__field" htmlFor="login-username">
                账号
                <input
                  id="login-username"
                  name="username"
                  autoComplete="username"
                  autoCapitalize="none"
                  spellCheck={false}
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                  placeholder="请输入账号"
                  minLength={3}
                  required
                />
              </label>
              <label className="login-page__field" htmlFor="login-password">
                密码
                <input
                  id="login-password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  placeholder="请输入密码"
                  minLength={6}
                  required
                />
              </label>
              {error !== null ? (
                <p className="login-page__error" role="alert">
                  {error}
                </p>
              ) : null}
              <button className="login-page__submit" type="submit" disabled={pending}>
                <span aria-live="polite">{pending ? '正在验证…' : '登录并进入平台'}</span>
                {!pending ? <span aria-hidden="true">→</span> : null}
              </button>
              <p className="login-page__account-note">
                学生、教师与管理员使用同一登录入口
                <br />
                登录后，自动进入对应工作台
              </p>
            </form>
          </section>
        </div>
        <footer className="login-page__footer">让围棋陪伴更好的时光</footer>
      </div>
    </main>
  );
}
